import React from 'react';
import styles from './UIGamePlayerInfoSectionContent.module.scss';
import { UIGameCardInventory } from '../../../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import IconUsedDevs from '@static/images/icon_used_devs.svg';
import { T } from '@colonist/ui';
import { CARD_STACK_SIZES_1 } from '../CardStateUnorderedStackSize1.ts';
export const UIGamePlayerInfoSectionContentUsedDevs = ({ cardState })=>{
    const isCardStateEmpty = Object.values(cardState).every((value)=>value === 0);
    if (isCardStateEmpty) {
        return /*#__PURE__*/ React.createElement("div", {
            className: styles.container
        }, /*#__PURE__*/ React.createElement("img", {
            src: IconUsedDevs,
            className: styles.usedDevsEmptyIcon
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.usedDevsEmptyText
        }, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.usedDevsEmpty"
        })));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        className: styles.usedDevsContainer,
        cardState: cardState,
        cardStackSizes: CARD_STACK_SIZES_1,
        cardsToGreyOut: cardState,
        cardSize: "xxs",
        forceShowCardBadges: true
    }));
};
